import './App.css';
import axios from 'axios';
import {useEffect, useState} from 'react';
import Categorias from './Components/Categorias/Categorias';
import Navbar from './Components/Navbar/Navbar';
import List from './Components/List/List';
import Footer from './Components/Footer/Footer';
import { Spinner } from 'reactstrap';
import 'bootstrap/dist/css/bootstrap.min.css';

const App = () => {
  const initialDates = [{
    ID: "",
    Name: "",
    Description: "",
    Price: "",
    Category: "",
    Image: ""
  }]

  const [datos, setDatos] = useState(initialDates);
  const [categorias, setCategorias] = useState([]);
  const [catActiva, setCatActiva] = useState();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
      const host = 'https://script.google.com/macros/s/AKfycbxMAgRK4oUR24CdF3T3CyhC6X4IGv9NGeB-4U24ftTkZvG2zqES5cfvwlQq_yL6P90F/exec';
  
      const readSpreadsheet = async () => {
        try {
          setIsLoading(true);
          const res = await axios(host);
          const dat = await res.data;
          const result = await dat.data;
          setDatos(result);
          obtenerCategorias(result);
          setIsLoading(false);
        } catch(e)  {}
      }

      const obtenerCategorias = (result) => {
        let catArr = [];
        const cat = result.map(row => {
          if (!catArr.includes(row.Category)) {
            catArr.push(row.Category);
          }
        })
        
        if (catArr.includes("")) {
          catArr = catArr.filter(c => c != "")
        }
        setCategorias(catArr);
        setCatActiva(catArr[0]);
      }

      readSpreadsheet();
  }, [])

  const seleccionada = (activa) => {
    setCatActiva(activa);
  }

  return (
    <div className="app">
      <Navbar />
      <div className='container'>
        {!isLoading
        ? <div> 
            <Categorias datos={categorias} selec={seleccionada} />
            <List datos={datos} selec={catActiva} />
            <Footer />
          </div>
        : <div className='spinnerContainer'>
              <Spinner />
          </div>
        }
      </div>
    </div>
  );
}

export default App;